import { render, staticRenderFns } from "./create-mainlandorder.vue?vue&type=template&id=fad5d370"
import script from "./create-mainlandorder.vue?vue&type=script&lang=ts"
export * from "./create-mainlandorder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports